import { useUpdate } from '@lib/systems/update'

class Wind {
  constructor () {
    this.direction = {
      x: 0,
      y: 0
    }
  }

  update () {
    this.direction.x = Math.sin(performance.now() * 0.00005) * (Math.random() * 0.25)
    this.direction.y = Math.cos(performance.now() * 0.00005) * (Math.random() * 0.25)
  }
}

const wind = new Wind()

export function enableWind () {
  useUpdate(() => {
    wind.update()
  }, {
    updateOrder: -1
  })
}

export function useWind () {
  return {
    direction: wind.direction
  }
}
